import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_unexpected_error = _resolveComponent("unexpected-error")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "starbridge-app" }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(_component_unexpected_error)
    ]),
    _: 1
  }))
}